import { cn } from "@/lib/cn";

export function Chip({
  active,
  children,
  onClick,
  className,
}: {
  active?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        "inline-flex h-9 items-center rounded-pill border px-4 text-sm font-medium transition-colors",
        active
          ? "border-leaf-green-ink bg-leaf-green-ink text-white"
          : "border-night-blue/15 bg-white text-night-blue/80 hover:border-leaf-green hover:text-leaf-green-ink",
        className,
      )}
    >
      {children}
    </button>
  );
}
